export default __webpack_public_path__ + "static/media/step1.ae97bd48.png";